angular.module('common.directives.flashMessages', [])
    .directive('flashMessages', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: ['$scope', 'flash', function ($scope, flash) {
                var context = this;

                context.flash = flash;
                $scope.flash = flash;

            }],
            templateUrl: 'flash-messages.tpl'
        };
    });